import { makeStyles } from '@mui/styles';

import Typography from '@classify/react-core-components/Typography';

import Card from '../Card';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ breakpoints, palette, spacing, shape, shadows }) => {
    const gradientBorder = {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: 0,
      right: 0,
      height: 8,
      background: palette.background.gradient.business,
    };

    return {
      root: {
        borderRadius: shape.borderRadius * 2,
        boxShadow: shadows.banner,
        position: 'relative',
        display: 'flex',
        '&:before': {
          ...gradientBorder,
          top: 0,
        },
        '&:after': {
          ...gradientBorder,
          bottom: 0,
          content({ isRaised }) {
            return isRaised ? '""' : '';
          },
        },
      },
      content: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingBottom: [spacing(4), '!important'],
      },
      header: {
        margin: spacing(4, 0),
        display: 'flex',
        flexDirection: 'column',
        [breakpoints.up('md')]: {
          flexDirection: 'row-reverse',
        },
      },
      titleContainer: {
        width: 'auto',
      },
      title: {
        color: palette.text.onMainSecondary,
      },
      subtitle: {
        color: palette.text.onMainSecondary,
        margin: [[spacing(0.5), 0, 0, 0]],
      },
      label: {
        color: palette.text.onMain,
        backgroundColor: palette.creativeAssets.thumbnail,
        borderRadius: [[20, 0, 0, 20]],
        padding: [[spacing(1), spacing(2)]],
        margin: [[0, spacing(-2), spacing(2), 'auto']],
        alignSelf: 'flex-end',
        display: 'inline-block',
        flexShrink: 0,
        [breakpoints.up('md')]: {
          alignSelf: 'flex-start',
        },
      },
      actions: {
        alignSelf: 'center',
        alignItems: 'center',
        marginTop: 'auto',
        paddingTop: spacing(2),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: spacing(2),
      },
    };
  },
  { classNamePrefix: 'PromoCard' }
);

export const PromoCard = ({
  actions = null,
  children = null,
  classes: customClasses = {},
  isRaised = false,
  label = '',
  title = '',
  subtitle = '',
  ariaLabel = 'Show more information',
  ...otherProps
}) => {
  const classes = useStyles({ isRaised, classes: customClasses });

  return (
    <Card
      {...otherProps}
      classes={{ content: classes.content, root: classes.root }}
      ariaLabel={ariaLabel}
    >
      {(title || subtitle || label) && (
        <div className={classes.header}>
          {label && (
            <Typography className={classes.label} variant="subheading" component="span">
              {label}
            </Typography>
          )}

          <div className={classes.titleContainer}>
            {title && (
              <Typography className={classes.title} variant="h3">
                {title}
              </Typography>
            )}

            {subtitle && (
              <Typography className={classes.subtitle} component="h4" variant="h5">
                {subtitle}
              </Typography>
            )}
          </div>
        </div>
      )}

      {children}

      {actions && <div className={classes.actions}>{actions}</div>}
    </Card>
  );
};

export default PromoCard;
